import { genShortID } from '@grafana/faro-core';
export function createSession(attributes) {
    return {
        id: genShortID(),
        attributes,
    };
}
//# sourceMappingURL=createSession.js.map